module.exports = __webpack_public_path__ + "img/39.4263f594.jpg";